<template>
    <v-row no-gutters>
        <v-col cols="12" class="pa-4">
            <v-row no-gutters justify="space-between" class="mb-3">
                <span class="header-text">{{$t('message.adminPage.status.status')}}</span>

                <v-btn small color="#EBEAEB">
                    <v-icon small left :color="getStatusState?.color">{{
                        getStatusState?.icon
                    }}</v-icon>
                    <span class="default-text-prompt">{{
                        getStatusState?.text
                    }}</span>
                </v-btn>
            </v-row>
            <div v-if="applicantInfo?.registrationStatus != 'NOT_QUALIFY'">
                <v-row no-gutters class="my-3">
                    <v-divider></v-divider>
                </v-row>
                <v-row no-gutters class="mb-3" v-if="autoAlert">
                    <v-col cols="12">
                        <span class="default-text">
                            <span class="text-red-dot">*</span
                            >{{$t('message.adminPage.status.statusContent')}}
                        </span>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-6">
                    <v-col cols="6">
                        <v-row no-gutters
                            ><span class="caption-text">{{$t('message.adminPage.status.dateAnnounce')}}</span>
                        </v-row>
                        <v-row no-gutters
                            ><span class="default-text">{{
                                announcementExamResultDate
                            }}</span>
                        </v-row>
                    </v-col>
                    <v-col cols="6">
                        <v-row no-gutters
                            ><span class="caption-text">{{$t('message.adminPage.status.time')}}</span>
                        </v-row>
                        <v-row no-gutters
                            ><span class="default-text">{{
                                applicant?.register_form
                                    ?.exam_authorize_announcement_time
                            }} {{$t('message.formSummit.time')}}</span>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-3">
                    <v-col cols="12">
                        <v-row no-gutters align="center">
                            <v-icon left size="20" color="secondary"
                                >mdi-information</v-icon
                            >
                            <span class="default-text">{{$t('message.adminPage.status.fillResult')}}</span>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12" class="mb-2">
                        <span class="default-text-bold">
                            {{$t('message.adminPage.status.passedHeader')}} <span class="text-red-dot">*</span>
                        </span>
                    </v-col>
                    <v-col cols="12" class="mb-2">
                        <v-radio-group
                            v-model="passRadio"
                            row
                            dense
                            class="my-0"
                        >
                            <v-col class="px-0"
                                ><v-radio
                                    :label="$t('message.adminPage.status.passed')"
                                    value="PASS"
                                    color="primary"
                                ></v-radio
                            ></v-col>
                            <v-col class="px-0">
                                <v-radio
                                    :label="$t('message.adminPage.status.notPassed')"
                                    value="FAILED"
                                    color="primary"
                                ></v-radio
                            ></v-col>
                        </v-radio-group>
                    </v-col>
                </v-row>
                <v-row
                    no-gutters
                    v-if="passRadio != 'FAILED' && passRadio != null"
                >
                    <v-col cols="12" class="mb-2">
                        <span class="default-text-bold">
                            {{$t('message.adminPage.status.fillType')}} <span class="text-red-dot">*</span>
                        </span>
                    </v-col>
                    <v-col cols="12" class="mb-2">
                        <v-radio-group
                            v-model="passTypeRadio"
                            row
                            dense
                            class="my-0"
                        >
                            <v-col class="px-0">
                                <v-radio
                                    :label="$t('message.adminPage.firstRound')"
                                    value="PASS"
                                    color="primary"
                                ></v-radio
                            ></v-col>
                            <v-col class="px-0">
                                <v-radio
                                    :label="$t('message.adminPage.reserveRound')"
                                    value="RESERVED"
                                    color="primary"
                                ></v-radio
                            ></v-col>
                        </v-radio-group>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-3" v-if="showSubstitutionOrder">
                    <v-col cols="12" class="mb-3">
                        <span class="default-text-bold">
                            {{ $t('message.adminPage.status.fillNo') }}
                            <v-tooltip right max-width="300">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        x-small
                                        color="#AFADB1"
                                        v-bind="attrs"
                                        v-on="on"
                                        >mdi-information</v-icon
                                    >
                                </template>
                                <span>
                                    {{ $t('message.adminPage.status.noTooltip.content1') }}
                                    <span class="text-red-dot"> *</span
                                    >{{ $t('message.adminPage.status.noTooltip.content2') }}
                                </span>
                            </v-tooltip>
                        </span>
                    </v-col>
                    <v-col cols="12" class="mb-3">
                        <v-text-field
                            dense
                            outlined
                            :placeholder="$t('message.adminPage.status.fillReservedNo')"
                            type="number"
                            v-model="substitutionOrder"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-3">
                    <v-col cols="12" class="mb-3">
                        <span class="default-text-bold">
                            {{$t('message.adminPage.status.score')}}
                            <v-tooltip right max-width="300">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        x-small
                                        color="#AFADB1"
                                        v-bind="attrs"
                                        v-on="on"
                                        >mdi-information</v-icon
                                    >
                                </template>
                                <span>
                                    {{$t('message.adminPage.status.scoreTooltip.content1')}}
                                    <span class="text-red-dot"> *</span>
                                    {{$t('message.adminPage.status.scoreTooltip.content2')}}
                                </span>
                            </v-tooltip>
                        </span>
                    </v-col>
                    <v-col cols="12" class="mb-3">
                        <v-text-field
                            dense
                            outlined
                            :placeholder="$t('message.adminPage.status.fillScore')"
                            type="number"
                            v-model="realScore"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-4">
                    <v-col cols="12" class="mb-3">
                        <v-btn
                            :disabled="disabledRules || waitExamDate"
                            width="100%"
                            rounded
                            color="primary"
                            class="default-text-prompt"
                            @click="onConfirmStatus"
                            >{{$t('message.adminPage.status.confirmAndAnnounce')}}
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </v-col>
    </v-row>
</template>

<script>
import { formatDateTimeLocale } from "@/utils/date";
import dayjs from "dayjs";
import i18n from '@/i18n';
export default {
    props: {
        applicantInfo: Object,
        getStatusState: Object,
        getButtonState: Object,
    },
    mounted() {
        this.retrievedData();
    },
    data() {
        return {
            applicant: {},
            passRadio: null,
            passTypeRadio: null,
            substitutionOrder: null,
            realScore: null,
        };
    },
    watch: {
        passRadio() {
            this.passTypeRadio = null;
            this.substitutionOrder = null;
            this.realScore = null;
        },
        passTypeRadio() {
            this.substitutionOrder = null;
            this.realScore = null;
        },
    },
    computed: {
        locale(){
            return i18n.locale;
        },
        waitExamDate() {
            let examDate = new Date(this.applicant?.register_form?.exam_date + " " + this.applicant?.register_form?.exam_start_time_phase1)
            if (dayjs(new Date()).isSameOrBefore(dayjs(examDate))) {
                return true;
            }
            return false;
        },
        announcementExamResultDate() {
            let newDate = Date.parse(
                this.applicant?.register_form?.announcement_exam_result_date
            );
            if (newDate) return formatDateTimeLocale(newDate, this.locale);
            else return "";
        },
        disabledRules() {
            if (this.substitutionOrder != null) {
                if (this.passRadio != null && this.passTypeRadio != null)
                    return false;
            }
            if (this.passRadio != null && this.passTypeRadio != null)
                return false;
            if (this.passRadio == "FAILED") return false;
            return true;
        },
        showSubstitutionOrder() {
            if (this.passRadio == "PASS" && this.passTypeRadio == "RESERVED") {
                return true;
            }
            return false;
        },
        autoAlert() {
            if (
                this.applicant?.registrationStatus == "EXAM_AUTHORIZE_BY_SYSTEM"
            )
                return true;
            return false;
        },
    },
    methods: {
        retrievedData() {
            let applicant = JSON.parse(JSON.stringify(this.applicantInfo));
            this.applicant = applicant;
        },
        onConfirmStatus() {
            const result_type =
                this.passRadio == "FAILED" ? "FAILED" : this.passTypeRadio;
            const result = {
                result_type: result_type,
                reserved_no: this.substitutionOrder,
                score: this.realScore,
            };
            if (result_type == "FAILED")
                this.$emit("onConfirmStatus", "fail_exam", { result });
            else
                this.$emit("onConfirmStatus", "pass_exam", { result });
        },
    },
};
</script>

<style scoped lang="scss">
.text-red-dot {
    color: #ff544a;
}
.header-text {
    font-family: "Prompt";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 23px;
    color: #255d98;
}
.caption-text {
    font-family: "Prompt";
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #9d9b9a;
}
.default-text-prompt {
    font-family: "Prompt";
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: #37323c;
}
.default-text {
    font-family: "Sarabun";
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: #37323c;
}
.default-text-bold {
    font-family: "Sarabun";
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    color: #37323c;
}

[class*="-text"] {
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}
.card-rounded {
    background: #ffffff;
    box-shadow: 0px 0px 20px rgba(232, 232, 232, 0.7) !important;
    border-radius: 10px 10px 10px 10px;
}
</style>
